import ButtonWithProgress from "components/ButtonWithProgress";
import React from "react";
import { useState } from "react";
import Modal from "react-responsive-modal";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useToasts } from "react-toast-notifications";
import WellnessService from "services/WellnessService";

const DeleteCompanyCultureVideo = ({
  onClose,
  videoId,
  setReload,
  isAudio = false,
  isDocument = false,
}) => {
  const params = useParams();
  const [submitting, setSubmitting] = useState(false);
  const { addToast } = useToasts();

  const deleteVideo = async () => {
    try {
      setSubmitting(true);
      await WellnessService.deleteVideo(videoId, params.teamId);
      setSubmitting(false);
      setReload(videoId);
      addToast("Content is deleted.", {
        appearance: "success",
      });
      onClose();
    } catch (e) {
      console.log(e);
      setSubmitting(false);
      addToast("Some error occurred while deleting the content.", {
        appearance: "error",
      });
    }
  };
  return (
    <Modal
      closeOnEsc={false}
      closeOnOverlayClick={false}
      classNames={{
        modalContainer: "modalContainer",
        modal: "listModal",
      }}
      open
      onClose={onClose}
    >
      <div className="p-4">
        <div className="shareVideoHeading">Are you sure?</div>
        <div className="shareVideoListContainer">
          <h5>You want to delete this {isDocument ? `document` : isAudio ? `audio` : `video`}?</h5>
        </div>
        <div>
          <ButtonWithProgress
            initialText="Delete"
            message="Deleting"
            buttonWithProgressClass="grad_btn full_w h-50"
            onClick={deleteVideo}
            isSubmitting={submitting}
            type="button"
          />
        </div>
      </div>
    </Modal>
  );
};

export default DeleteCompanyCultureVideo;
